export const MATTER_EDITOR_CLIENT_MATTER_DETAILS = "clientmatterdetails";
export const MATTER_EDITOR_PRICING_STRUCTURE = "pricingstructure";
export const MATTER_EDITOR_SCOPE = "scope";
export const MATTER_EDITOR_ASSUMPTIONS = "assumptions";
export const MATTER_EDITOR_EXCLUSIONS = "exclusions";
export const MATTER_EDITOR_DISBURSEMENTS = "disbursements";
export const MATTER_EDITOR_UPLIFTS = "uplifts";
export const MATTER_EDITOR_DISCOUNTS = "discounts";
export const MATTER_EDITOR_FEE_RISK_PROFILE = "feeriskprofile";
export const MATTER_EDITOR_DEFAULT_CHILD = MATTER_EDITOR_SCOPE;
export const MATTER_EDITOR_CHILD_KEYS: readonly string[] = [
  MATTER_EDITOR_SCOPE,
  MATTER_EDITOR_ASSUMPTIONS,
  MATTER_EDITOR_EXCLUSIONS,
  MATTER_EDITOR_DISBURSEMENTS,
  MATTER_EDITOR_UPLIFTS,
  MATTER_EDITOR_DISCOUNTS,
  MATTER_EDITOR_PRICING_STRUCTURE,
  MATTER_EDITOR_CLIENT_MATTER_DETAILS,
  MATTER_EDITOR_FEE_RISK_PROFILE,
];
export type MATTER_EDITOR_CHILD_KEYS_T =
  | typeof MATTER_EDITOR_SCOPE
  | typeof MATTER_EDITOR_ASSUMPTIONS
  | typeof MATTER_EDITOR_EXCLUSIONS
  | typeof MATTER_EDITOR_DISBURSEMENTS
  | typeof MATTER_EDITOR_UPLIFTS
  | typeof MATTER_EDITOR_DISCOUNTS
  | typeof MATTER_EDITOR_PRICING_STRUCTURE
  | typeof MATTER_EDITOR_CLIENT_MATTER_DETAILS
  | typeof MATTER_EDITOR_FEE_RISK_PROFILE;
